var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationProvider", {
    ref: "provider",
    attrs: {
      rules: _vm.rules ? _vm.veeValidateRules : undefined,
      name: _vm.$attrs.props ? _vm.$attrs.props.label || undefined : undefined,
      vid: _vm.getVid,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ errors, validate }) {
            return [
              _vm._t("default", null, null, {
                attrs: {
                  rules: _vm.rules ? _vm.vuetifyInputRules : undefined,
                  errorMessages: errors,
                },
                validateInput: validate,
              }),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }